import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { FeatureService } from '@app/_components/property/feature';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Feature } from '@app/_components/property/feature';
import { LazyLoadEvent } from 'primeng/api';

import { take } from 'rxjs/operators';




@Component({
    selector: 'app-feature',
    templateUrl: './feature.component.html',
    styleUrls: ['./feature.component.css'],
    standalone: false
})
export class FeatureComponent implements OnInit, OnChanges {

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private featureService: FeatureService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) { }

	// inputs

	@Input() shortTermRentalId: number;
	@Input() developmentId: number;
	@Input() describesType: string;
	@Input() featureType: string;
	@Input() featuresList: Feature[] = [];
	@Input() title: string;

	features: Feature[] = [];
	// structure
	subscription: Subscription;
	routerLocation = this.location;


	// data
	featureApiResponse: ApiResponse;

	// list
	datasource: Feature[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;

	multiSortMeta = [];


	// forms
	featureAddForm: UntypedFormGroup;
	featureEditForm: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;




	distanceUnits = [
		{ value: 'inch', name: 'Inches' },
		{ value: 'feet', name: 'Feet' },
		{ value: 'yard', name: 'Yards' },
		{ value: 'mile', name: 'Miles' },
		{ value: 'meter', name: 'Meters' },
		{ value: 'kilometer', name: 'Kilometers' },
		{ value: 'minute', name: 'Minutes' },
		{ value: 'hour', name: 'Hours' },
		{ value: 'day', name: 'Days' },
		{ value: 'sq_in', name: 'Sq. Inches' },
		{ value: 'sq_ft', name: 'Sq.Ft.' }

	];

	columns: any[] = [
		{ field: 'title', header: 'title', width: 'auto' },
		{ field: 'name', header: 'name', width: 'auto' },
		{ field: 'featureLabel', header: 'featureLabel', width: 'auto' },
		{ field: 'featureDesc', header: 'featureDesc', width: 'auto' },
		{ field: 'quantity', header: 'quantity', width: 'auto' },
		{ field: 'distance', header: 'distance', width: 'auto' },
		{ field: 'distanceUnit', header: 'distanceUnit', width: 'auto' },
	];


	filters: any[] = [

		{ label: 'Created', value: 'createDate' },
		{ label: 'Edited', value: 'lastUpdate' },
		{ label: 'Status', value: 'status' },
		{ label: 'Type', value: 'featureType' },
		{ label: 'Visibility', value: 'visibility' },

	];


	// validation
	validationMessages = {
		'title': [],
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'featureId': [],
		'createDate': [],
		'lastUpdate': [],
		'featureDesc': [{ type: 'required', message: 'Required' }],
		'status': [],
		'featureType': [],
		'featureLabel': [],
		'quantity': [],
		'distance': [],
		'distanceUnit': [],
		'describesType': [],
		'privateNotes': []
	};


	ngOnInit() {
		// // console.log('describesType' + this.describesType);
		// if we have a featureType type with multiple describeTypes (ie bedrooms), get the list specific to the room
		if (this.describesType && this.describesType.length > 0 && this.shortTermRentalId) {
			this.findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType();
		}
		else if (this.describesType && this.describesType.length > 0 && this.developmentId) {
			this.findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType();
		}



		// filter the featureType
		this.filterFeatureType();
		this.buildEditForm();

		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			 // console.log('Error: ' + error);
		}
	}

	



	formAddFeature(feature: any) {
		try {
			// console.log('Form Add Submitted: ' + JSON.stringify(feature));
			this.formLoading = true;

			// use the .pipe(take(1)) to prevent double firing...
			this.featureService.add(feature).pipe(take(1))
				.subscribe(
					res => {
						console.log('Feature-Add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);

						this.features.map((featureEntry, i) => {

							console.log('if '+featureEntry.featureId + '==' + res.data.propertyFeature.featureId + ' && ' + this.describesType + '/' + res.data.propertyFeature.describesTyp);

							if (featureEntry.featureId === res.data.propertyFeature.featureId && this.describesType === res.data.propertyFeature.describesType) {
								console.log('MATCH' + featureEntry.describesType + ' ' + res.data.propertyFeature.describesType);
								this.features[i].propertyFeatureId = res.data.propertyFeature.propertyFeatureId;
							}
						});
					},
					err => {
						// console.log('Feature-Add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate(feature) {
		try {
			// stop here if form is invalid
			// console.log('Form Update Submitted: ' + JSON.stringify(this.featureEditForm.value));
			if (this.featureEditForm.invalid) {
				// console.log('Form Invalid: ' + JSON.stringify(this.featureEditForm.getError));
				return;
			}

			this.formLoading = true;

			// create a custom object
			feature.title = this.featureEditForm.get('title').value;
			feature.quantity = this.featureEditForm.get('quantity').value;
			feature.distance = this.featureEditForm.get('distance').value;
			feature.distanceUnit = this.featureEditForm.get('distanceUnit').value;
			feature.featureDesc = this.featureEditForm.get('featureDesc').value;

			this.featureService.update(feature)
				.subscribe(
					res => {
						// console.log('Feature-Update SUCCESS: ' + JSON.stringify(res));

						// update the list
						this.features.map((featureEntry, i) => {
							if (featureEntry.featureId === res.data.propertyFeature.featureId && featureEntry.describesType === res.data.propertyFeature.describesType) {
								this.features[i].propertyFeatureId = res.data.propertyFeature.propertyFeatureId;
							}
						});
						this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formUpdateStatus(featureObject: any) {
		try {
			// stop here if form is invalid
			// console.log('Feature Submitted: ' + JSON.stringify(featureObject));

			this.formLoading = true;
			this.featureService.updateStatus(featureObject)
				.subscribe(
					res => {
						// console.log('Feature-Update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}


	findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType() {
		try {
			this.formLoading = true;
			this.featureService.findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType(this.shortTermRentalId, this.describesType, this.featureType).pipe(take(1))
				.subscribe(
					res => {
						// // console.log('findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType Id#' + this.shortTermRentalId + ' ' + this.describesType);
						this.featuresList = res.data.propertyFeatures;
						this.features = this.featuresList;
						this.filterFeatureType();
						// this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType() {
		try {
			this.formLoading = true;

			// BUGFIX: 9-23-2020 this was miscoded to findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType so it was returning str options instead of dev options
			this.featureService.findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType(this.developmentId, this.describesType, this.featureType).pipe(take(1))
				.subscribe(
					res => {
						// // console.log('findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType' + this.developmentId + ' ' + this.describesType);
						this.featuresList = res.data.propertyFeatures;
						this.features = this.featuresList;
						this.filterFeatureType();
						// this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	loadLazy(event: LazyLoadEvent) {
		// pick up here
		this.lazyLoadEvent = event;
		const pageNumber = Math.round(event.first / event.rows);
		console.log(
			' event.first:' + event.first
			+ '  |  event.rows:' + event.rows
			+ '  |  event.sortField:' + event.sortField
			+ '  |  event.sortOrder:' + event.sortOrder
			+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
			+ '  |  event.globalFilter:' + event.globalFilter
			+ '  |  event.filters:' + JSON.stringify(event.filters)
		);

		this.featureService.findByFilter
			(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters
			).pipe(first()).subscribe(

				apiResponse => {
					// console.log('features are: ' + JSON.stringify(apiResponse));
					this.datasource = apiResponse.data.features;
					this.features = apiResponse.data.features;
					this.recordTotal = apiResponse.page.recordTotal;
				},
				apiResponse => {
					// console.log('Feature failure: ' + JSON.stringify(apiResponse));
					this.alertService.error(apiResponse);
				},
				() => { this.loading = false; }
			);

		try {
			if (this.datasource) {
				this.features = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			// console.log('loadLazy(' + event + ')' + error);
		}
	}



	onStatusChange(event, feature) {
		// console.log('onStatuChange', event);
		if (event.checked) {
			// if an existing propertyFeature, update status to 1 and keep all the existing data
			if (feature.propertyFeatureId) {
				// console.log('onStatuChange', 'CHECKED!');
				// console.log('onStatuChange', feature);
				feature.status = true;
				this.formUpdateStatus(feature);
			}
			else {
				// create a new one with just the basic info.  More editing can be done once enabled.
				let newFeature: any = {};
				newFeature.status = true;
				newFeature.featureId = feature.featureId;
				newFeature.describesType = this.describesType;
				newFeature.shortTermRentalId = this.shortTermRentalId;
				newFeature.developmentId = this.developmentId;
				this.formAddFeature(newFeature);
			}
		}
		else {
			// console.log('onStatuChange', 'UNCHECKED!');
			// if an existing propertyFeature, update status to 0
			if (feature.propertyFeatureId) {
				feature.status = false;
				this.formUpdateStatus(feature);
			}
			else {
				// do nothing.  Not sure how we would get here.
			}
		}
	}

	isStatusChecked(feature) {
		// // console.log('isStatusChecked', feature);
		if (feature && feature.propertyFeatureId && feature.status === true) {
			return true;
		}
		return false;
	}


	sortList(event) {
		// console.log('formTest', event);
		this.multiSortMeta = [];
		this.multiSortMeta.push({ field: event.value.value, order: 0 });
		this.lazyLoadEvent.multiSortMeta = this.multiSortMeta;
		this.loadLazy(this.lazyLoadEvent);
	}


	ngOnChanges() {
		// This is called when the parent property. When the parent first initializes, it has not got the features yet.  This updates the list when the features are ready.
		this.features = this.featuresList;
		this.filterFeatureType();
	}

	filterFeatureType() {
		// to filter a list https://stackoverflow.com/questions/34901593/how-to-filter-an-array-from-all-elements-of-another-array
		this.features = this.featuresList.filter(feature => feature.featureType === this.featureType);
	}


	buildEditForm() {
		this.featureEditForm = this.formBuilder.group({
			featureId: [],
			propertyFeatureId: [],
			shortTermRentalId: [this.shortTermRentalId],
			status: [],
			name: [],
			title: [],
			featureType: [],
			featureLabel: [],
			featureDesc: [],
			quantity: [],
			distance: [],
			distanceUnit: [],
			describesType: [this.describesType],
			privateNotes: [],
		});
	}

	patchFeature(feature) {
		this.featureEditForm.patchValue(feature);
	}

	displayPaginator() {
		if (this.features && this.features.length > 25) {
			return true;
		}
		else {
			return false;
		}
	}
}